import React from 'react';
import { CreateRoomsForm } from 'modules/components/layer12';
import { BasicFormModalLayout } from 'modules/components/layer13';

export type CreateRoomsModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

export const FC = (props: CreateRoomsModalProps) => {

  return (
    <BasicFormModalLayout.FC
      id={props.id}
      title='Create rooms'
      subTitle='Enter details in order to save them to the system.'
      handleClose={props.handleClose}
      isVisible={props.isVisible}
    >
      <CreateRoomsForm.FC
        id={props.id}
        handleClose={props.handleClose}
      />
    </BasicFormModalLayout.FC>
  );

};
